import { Signal, ValueEqualityFn } from '@angular/core';
import { MultiSelectService } from '../services/selection/multi-select.service';
import { ExplorerAddon, ExplorerAddonFactory } from './explorer';

export interface MultiSelectExplorer<T> extends ExplorerAddon<T>{
  selected: Signal<T[]>;
  selectedIndexes: Signal<number[]>;
  select(value: T): void;
  unselect(value: T): void;
  selectAll(): void;
  unselectAll(): void;
  setSelected(values: T[]): void;
}

export interface MultiSelectExplorerOptions<T> {
  equals?: ValueEqualityFn<T>
  keepPreviousSelection?: undefined | 'equality' | 'index';
}

export function withMultiSelect<T>(options?: MultiSelectExplorerOptions<T>): ExplorerAddonFactory<T, MultiSelectExplorer<T>> {
  return (source: Signal<T[]>): MultiSelectExplorer<T> => multiSelect<T>(source, options);
}

function multiSelect<T>(source: Signal<T[]>, options?: MultiSelectExplorerOptions<T>): MultiSelectExplorer<T> {
  const service = new MultiSelectService<T>(source, options);
  return service;
}
